module.exports = __webpack_public_path__ + "static/media/clemente_castor_10.c138084a.jpg";